import React, { useState, useContext } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import MessageContext from "../Context/MessageContext";
import { resetPasswordApi, ResetPasswordInput } from "../utils/GeneBoxAPI";
import Modal from "../component/Modal";

const defaultValues: ResetPasswordInput = {
    current_password: "",
    new_password: "",
};

const ResetPassword = () => {
    const {
        formState: { errors },
        register,
        handleSubmit,
        reset,
    } = useForm<ResetPasswordInput>({ defaultValues });

    const [isShowModal, setIsShowModal] = useState(false);

    // message
    const { alertProps, setAlertProps, setIsAlert } =
        useContext(MessageContext);

    const onSubmit: SubmitHandler<ResetPasswordInput> = (data) => {
        resetPasswordApi(data)
            .then((res) => {
                if (res.error_code === 0) {
                    setAlertProps({
                        ...alertProps,
                        title: "密碼修改成功",
                        iMsg: 0,
                    });
                    setIsAlert(true);
                    onClose();
                }
            })
            .catch(() => {
                setAlertProps({
                    ...alertProps,
                    title: "密碼驗證失敗",
                    iMsg: 1,
                });
                setIsAlert(true);
            });
    };

    const onClose = () => {
        reset();
        setIsShowModal(false);
    };

    const inputList = [
        {
            name: "current_password",
            label: "原始密碼",
            setting: {
                required: { value: true, message: "此欄位必填" },
                minLength: { value: 8, message: "最少輸入八個字" },
            },
        },
        {
            name: "new_password",
            label: "新密碼",
            setting: {
                required: { value: true, message: "此欄位必填" },
                minLength: { value: 8, message: "最少輸入八個字" },
            },
        },
    ];

    const modalProps = {
        Md_Modal_title: <>密碼修改</>,
        Mdtitle: "",
        Mdcontent: (
            <>
                <form className="reset_form">
                    {inputList.map(({ name, label, setting }) => (
                        <div key={name} className="dialog_form_item">
                            <label className="dialog_label" htmlFor={name}>
                                {label}
                            </label>
                            <div className="dialog_row">
                                <input
                                    type="password"
                                    className="dialog_input"
                                    id={name}
                                    {...register(name, setting)}
                                />

                                {errors[name] && (
                                    <p className="error_text">
                                        {errors[name]?.message}
                                    </p>
                                )}
                            </div>
                        </div>
                    ))}
                </form>
            </>
        ),
        Mdtitle_bgcolor: "bg_blue_green",
        MdBtnType: 1,
        MdsubmitFun: () => handleSubmit(onSubmit)(),
        MdcloseFun: () => onClose(),
    };

    return (
        <>
            <div className="user_status">
                <button className="logout" onClick={() => setIsShowModal(true)}>
                    密碼修改
                </button>
            </div>
            {isShowModal && <Modal {...modalProps} />}
        </>
    );
};
export default ResetPassword;
